export class InputBoxData {
    label: string;
    message?: string;
    primary?: string;
}

export class InputBoxEmit {
    action: boolean;
    name: string;
    constructor(action: boolean, name: string) {
        this.action = action;
        this.name = name;
    }
}